var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLUE } from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
import PhaseBadge from '@govuk-react/phase-badge';
var StyledBanner = styled('div')((_styled = {
  borderBottom: '1px solid #bfc1c3',
  boxSizing: 'border-box',
  paddingTop: '10px',
  paddingBottom: '10px',
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled['> a'] = {
  color: BLUE
}, _styled));
/**
 *
 * ### Usage
 *
 * Alpha
 * ```jsx
 * <PhaseBanner level="alpha">
 *    This part of GOV.UK is being rebuilt &#8211;{' '}
 *    <AnchorLink href="https://example.com">find out what that means</AnchorLink>
 *  </PhaseBanner>
 * ```
 *
 * Beta
 * ```jsx
 * <PhaseBanner level="beta">
 *    This part of GOV.UK is being rebuilt &#8211;{' '}
 *    <AnchorLink href="https://example.com">find out what that means</AnchorLink>
 *  </PhaseBanner>
 * ```
 *
 * ### References:
 * - https://govuk-elements.herokuapp.com/alpha-beta-banners/
 *
 */

var PhaseBanner = function PhaseBanner(_ref) {
  var level = _ref.level,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["level", "children"]);

  return React.createElement(StyledBanner, props, React.createElement(PhaseBadge, null, level), children);
};

export default withWhiteSpace({
  marginBottom: 0
})(PhaseBanner);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/phase-banner/es/index.js
// module id = 274
// module chunks = 0